<script setup>
import { useUserStore } from "@/stores/user";
const user = useUserStore();
const props = defineProps(["size"]);
</script>

<template>
    <v-avatar color="primary" :size="props.size">
        <v-img
            v-if="user.data && user.data.photo"
            :src="user.data.photo"
        ></v-img>
        <span v-else class="text-h6">{{ user.initials }}</span>
    </v-avatar>
</template>
